import type { LoadCookiesDataResult } from "./loadCookiesData";
import type { AuthAccessInfo } from "~/types";

type AuthContextCacheEntry = {
  uid: string;
  result: LoadCookiesDataResult;
};

let cache: AuthContextCacheEntry | null = null;

export function getAuthContextCache(uid: string): LoadCookiesDataResult | null {
  if (!cache || cache.uid !== uid) {
    return null;
  }
  return cache.result;
}

export function setAuthContextCache(
  uid: string,
  result: LoadCookiesDataResult,
): void {
  cache = { uid, result };
}

export function invalidateAuthContextCache(): void {
  cache = null;
}

/** True when loadCookiesData has a successful cached entry for the session. */
export function isAuthContextCacheValid(): boolean {
  return cache?.result.success === true;
}

export function getCachedAuthAccessInfo(): AuthAccessInfo | null {
  if (!cache?.result.success) {
    return null;
  }
  return cache.result.data;
}
